import {Component, Input} from '@angular/core';

@Component({
  selector: 'menu-button',
  templateUrl: 'menu-button.html',
  styleUrls: ['menu-button.scss'],
})
export class MenuButton {

  @Input('icon') public iconName: string;

}
